<template>
	<header ref="el" data-component="header">
		<span class="inner-bg" />
		<div class="background-container">
			<!-- <ImageAsset v-if="background.image" :asset="background.image" class="desktop-image" /> -->

			<!-- <nuxt-img class="desktop" src="/imgs/temp/exp.jpg" alt="desktop header graphic" />
			<nuxt-img class="mobile" src="/imgs/temp/mobileheader.jpg" alt="mobile header graphic" /> -->

			<ClientOnly>
				<Waves />
			</ClientOnly>
		</div>
		<div class="g-row">
			<div class="g-col xxl-8 sm-12 sm-offset-1 xs-16">
				<div class="uppertitle-wrapper">
					<p class="-label-regular uppertitle">{{ upperTitle }}</p>

					<div class="segments-wrapper">
						<!-- <svg
							class="line-graphic connector-profile-desktop segment-one"
							data-segment-order="1"
							data-segment-profile="desktop"
							width="797"
							height="327"
							viewBox="0 0 797 327"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0 0.750061H332.698C356.09 0.750061 378.756 8.88061 396.814 23.7501C414.873 38.6195 437.539 46.7501 460.931 46.7501H518H684C723.204 46.7501 742.806 46.7501 757.779 54.3796C770.951 61.0907 781.659 71.7994 788.37 84.9707C796 99.9445 796 119.58 796 158.85C796 204.505 796 177.647 796 326.25"
								stroke="#0551F5"
								stroke-width="1.5"
							/>
						</svg> -->
						<svg
							class="line-graphic connector-profile-desktop segment-one"
							data-segment-order="1"
							data-segment-profile="desktop"
							width="797"
							height="327"
							viewBox="0 0 797 327"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0 0.750061H332.698C356.09 0.750061 378.756 8.88061 396.814 23.7501C414.873 38.6195 437.539 46.7501 460.931 46.7501H518H684C723.204 46.7501 742.806 46.7501 757.779 54.3796C770.951 61.0907 781.659 71.7994 788.37 84.9707C796 99.9445 796 119.58 796 158.85C796 204.505 796 177.647 796 326.25"
								stroke="#0551F5"
								stroke-width="1.5"
							/>
						</svg>

						<svg
							class="line-graphic connector-profile-mobile segment-one-mobile"
							data-segment-order="1"
							data-segment-profile="mobile"
							data-anchor-reverse="true"
							viewBox="0 0 330 205"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M329 204.75V68.2078C329 64.5247 329 62.6832 328.521 61.1914C327.535 58.1215 325.129 55.7155 322.059 54.7292C320.567 54.25 318.725 54.25 315.042 54.25C309.363 54.25 306.523 54.25 303.786 53.8698C298.201 53.0942 292.843 51.1466 288.063 48.1548C285.72 46.6881 283.544 44.8646 279.19 41.2177L248.715 15.6891C242.111 10.1567 238.808 7.39044 235.1 5.42121C231.81 3.67434 228.292 2.39559 224.648 1.62203C220.54 0.75 216.233 0.75 207.617 0.75H0"
								stroke="#0551F5"
								stroke-width="1.5"
							/>
						</svg>
					</div>
				</div>
				<h1 class="-title-1 title">
					<SanityContent :value="title" :components="components" />
				</h1>
				<div class="description-col">
					<p class="-body-big-regular mobile">{{ description }}</p>
				</div>
				<div v-if="ctas" class="ctas-container">
					<Button v-for="(cta, k) in ctas" :key="k" v-bind="cta" :tone="k === 0 ? 'primary' : 'secondary'" />
				</div>
			</div>
			<div class="g-col xxl-4 sm-8 description-col desktop">
				<p class="-body-big-regular">{{ description }}</p>
			</div>
		</div>
	</header>
</template>

<script setup>
import { h } from 'vue'

import { useEmitter } from '~/composables/core'
import { Button } from '~/components/primitives'
import { createHeaderMotion } from './Header.motion.js'

const Waves = defineAsyncComponent(() => import('@/components/sections/Three/Waves.vue'))

defineProps({
	upperTitle: { type: String, default: undefined },
	title: { type: [Array, Boolean], default: undefined },
	description: { type: String, default: undefined },
	ctas: { type: Array, default: undefined },
	background: { type: Object, default: undefined },
})

const components = {
	block: {
		normal: (_, { slots }) => {
			return h('span', { class: 'title-line' }, slots.default?.())
		},
	},
}

const el = ref(null)
const context = inject('pageContext')
const emitter = useEmitter()
const headerRouteKey = context?.$page?.slug || ''
const motion = createHeaderMotion({ el, loader: context?.$page?.loader, emitter, routeKey: headerRouteKey })

onBeforeUnmount(() => motion.kill())
onMounted(() => {
	motion.mount()
})
</script>

<style lang="scss" scoped>
[data-component='header'] {
	position: relative;

	display: flex;
	align-items: flex-end;

	width: 100%;
	height: 100vh;

	color: var(--color-geral-black);
	background-color: var(--color-geral-white);

	.inner-bg {
		position: absolute;
		inset: rs(16, 12);
		border-radius: rs(34, 24);
		background-color: var(--color-river-blue-50);
		overflow: hidden;
	}

	.g-row {
		justify-content: space-between;
		margin-bottom: rs(50, 50);

		@include max-width($sm) {
			margin-bottom: rs(60, 40);
		}
	}

	.background-container {
		mix-blend-mode: darken;

		position: absolute;
		inset: rs(16, 12);
		border-radius: rs(34, 34);
		overflow: hidden;

		:deep(img) {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.g-row {
		position: relative;
	}

	.uppertitle-wrapper {
		position: relative;

		.segments-wrapper {
			position: absolute;
			inset: 0;
			pointer-events: none;
			overflow: visible;
		}

		.line-graphic {
			--sixteen: #{rs(16, 16)};
			--left-clip-size: #{calc(var(--grid-padding) + var(--sixteen))};

			position: absolute;
			top: 0;
			left: 0;
			z-index: 1;

			clip-path: inset(0 0 0 var(--left-clip-size));

			width: calc(column-width(7, true) + #{rs(91, 91)} + var(--grid-half-gap));
			height: auto;

			@include max-width($sm) {
				--sixteen: #{rs(16, 12)};
				--left-clip-size: #{calc(var(--grid-padding) + var(--sixteen) + column-width(1, true))};

				clip-path: inset(0 0 0 var(--left-clip-size));

				width: calc(column-width(15, true) + var(--grid-half-gap));
			}
			@include max-width($xs) {
				--sixteen: #{rs(16, 12)};
				--left-clip-size: #{calc(var(--grid-padding) + var(--sixteen) + column-width(1, true))};

				clip-path: inset(0 0 0 var(--left-clip-size));

				width: calc(column-width(14) - var(--grid-gap));
			}

			@include min-width(1920px) {
				width: 47.4vw !important;
			}

			@include min-width(2101px) {
				width: 47.6vw !important;
			}
		}

		.connector-profile-desktop {
			display: block;
			visibility: visible;
		}

		.connector-profile-mobile {
			display: none;
			visibility: hidden;
		}

		@media (max-width: 743px) {
			.connector-profile-desktop {
				display: none;
				visibility: hidden;
			}

			.connector-profile-mobile {
				display: block;
				visibility: visible;
			}
		}

		@media (min-width: 744px) and (max-width: 1000px) {
			.connector-profile-desktop,
			.connector-profile-mobile {
				display: none;
				visibility: hidden;
			}
		}

		.uppertitle {
			color: var(--color-geral-white);
			background-color: var(--color-river-blue-500);

			width: fit-content;
			padding: rs(10, 10);
			margin-bottom: rs(32, 32);

			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	}

	.title {
		position: relative;
		z-index: 2;

		white-space: pre-line;
		color: var(--color-neutral-tints-900);

		:deep(div) {
			@include inherit-font;
		}
	}

	.title :deep(.title-line) {
		display: block;
		@include inherit-font;
	}

	.title :deep(.split-line) {
		display: block;
		line-height: inherit;
		@include inherit-font;
	}

	.title :deep(.split-line > *) {
		display: block;
		line-height: inherit;
		@include inherit-font;
	}

	.title :deep(strong) {
		color: var(--color-river-blue-500);
		@include inherit-font;
	}

	.ctas-container {
		display: flex;
		gap: rs(24, 12);
		margin-top: rs(32, 32);

		@include max-width($sm) {
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
		}
	}

	.description-col {
		display: flex;
		align-items: flex-end;

		@include max-width($sm) {
			padding-right: column-width(3);
			margin-top: rs(12, 12);
		}

		.-body-big-regular {
			color: var(--color-neutral-tints-700);
		}
	}

	.mobile {
		display: none;
		visibility: hidden;
		pointer-events: none;
	}
	.desktop {
		display: flex;
	}

	@include max-width($sm) {
		.mobile {
			display: block;
			visibility: visible;
			pointer-events: all;
		}
		.desktop {
			display: none;
			visibility: hidden;
			pointer-events: none;
		}
	}
}
</style>
